module.exports = __webpack_public_path__ + "static/media/OSC.bbcedc4a.jpg";